import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLayerGroup, FaCalendarAlt, FaTrophy, FaMapMarkerAlt, FaClipboardList, FaUserTie, FaClock, FaMedal } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import './Modalidades.css';
import PreInscricaoModal from '../components/Home/Modalidades/PreInscricaoModal';
import API_BASE_URL from '../config/api';

const Modalidades = () => {
  const [modalidades, setModalidades] = useState([]);
  const [escalaos, setEscalaos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalidadeSelecionada, setModalidadeSelecionada] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [sportsRes, escalaosRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/sports`),
        fetch(`${API_BASE_URL}/api/escalaos`)
      ]);

      if (sportsRes.ok) {
        const sportsData = await sportsRes.json();
        setModalidades(sportsData);
      }

      if (escalaosRes.ok) {
        const escalaosData = await escalaosRes.json();
        setEscalaos(escalaosData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&h=600&fit=crop';
    if (imageUrl.startsWith('http')) return imageUrl;
    return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
  };

  // Informações detalhadas estáticas para cada modalidade
  const modalidadesDetalhes = {
    'Atletismo': {
      detalhes: [
        { icon: <FaLayerGroup />, label: 'Escalões', value: 'Benjamins a Veteranos (9 escalões)' },
        { icon: <FaTrophy />, label: 'Nível Competitivo', value: 'Apuramento Divisão Nacional' },
        { icon: <FaMapMarkerAlt />, label: 'Instalações', value: 'Estádio Municipal (uma das melhores pistas do país)' }
      ],
      conquistas: [
        'Bicampeão Nacional II Divisão Feminina (1999/00, 2000/01)',
        'Fátima Silva: 7× Campeã Nacional de Maratona (1999-2006)'
      ]
    },
    'Badminton': {
      detalhes: [
        { icon: <FaClipboardList />, label: 'Programa', value: 'Formação e Competição' },
        { icon: <FaTrophy />, label: 'Nível Competitivo', value: 'Competição Distrital' },
        { icon: <FaMapMarkerAlt />, label: 'Local de Treino', value: 'Pavilhão Gimnodesportivo Fernando Linhares' }
      ]
    },
    'Basquetebol': {
      detalhes: [
        { icon: <FaLayerGroup />, label: 'Escalões', value: 'Baby-Basket a Seniores' },
        { icon: <FaClock />, label: 'Horários', value: 'Treinos: Segunda, Quarta e Sexta' },
      ],
      conquistas: [
        'Campeão Nacional I Divisão Feminina (1999/2000)',
        'Clube do Ano ABP (2004, 2007)'
      ]
    },
    'Futevólei': {
      detalhes: [
        { icon: <FaLayerGroup />, label: 'Escalões', value: 'Sub-18, Seniores, Masters' },
        { icon: <FaTrophy />, label: 'Nível Competitivo', value: 'Campeonato Nacional' },
        { icon: <FaMedal />, label: 'Estatuto', value: 'Maior clube nacional em número de duplas' }
      ],
    },
    'Futsal': {
      detalhes: [
        { icon: <FaLayerGroup />, label: 'Escalões', value: 'Sub-7 a Sub-19, Seniores' },
        { icon: <FaClock />, label: 'Horários', value: 'Treinos: Terça, Quinta e Sábado' },
        { icon: <FaUserTie />, label: 'Treinador Principal', value: 'Manuel Costa' }
      ]
    },
    'Hóquei em Patins': {
      detalhes: [
        { icon: <FaLayerGroup />, label: 'Escalões', value: 'Sub-9 a Sub-23, Seniores A e B' },
        { icon: <FaTrophy />, label: 'Nível Competitivo', value: '1ª Divisão Nacional' },
        { icon: <FaUserTie />, label: 'Coordenador', value: 'Nuno Carrão (Campeão Mundial Sub-20)' }
      ],
      conquistaRecente: [
        'Campeão 2ª Divisão Zona Norte (2024/25)',
        'Promoção à 1ª Divisão Nacional'
      ]
    },
    'Ténis de Mesa': {
      detalhes: [
        { icon: <FaClipboardList />, label: 'Programa', value: 'Formação e Competição' },
        { icon: <FaTrophy />, label: 'Nível Competitivo', value: 'Competição Distrital' },
        { icon: <FaMapMarkerAlt />, label: 'Local de Treino', value: 'Pavilhão Gimnodesportivo Fernando Linhares' }
      ]
    },
    'Voleibol': {
      detalhes: [
        { icon: <FaLayerGroup />, label: 'Escalões', value: 'Mini a Seniores' },
        { icon: <FaClock />, label: 'Horários', value: 'Treinos: Terça, Quinta e Domingo' },
        { icon: <FaUserTie />, label: 'Treinador Principal', value: 'Pedro Costa' }
      ],
      conquistasRecentes: [
        'Bicampeão Nacional Masters Femininos (2024, 2025)',
        'Campeão Nacional Masters Masculinos (2025)'
      ]
    }
  };

  if (loading) {
    return (
      <div className="modalidades-page">
        <section className="modalidades-hero">
          <div className="container">
            <div className="modalidades-hero-content">
              <h1>As Nossas Modalidades</h1>
              <p>A carregar modalidades...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="modalidades-page">
      {/* Hero Section */}
      <section className="modalidades-hero">
        <div className="container">
          <div className="modalidades-hero-content">
            <h1>As Nossas Modalidades</h1>
            <p>Programas de formação e competição de elite para todas as idades, focados no desenvolvimento integral do atleta.</p>
          </div>
        </div>
      </section>

      {/* Quick Links Navigation */}
      <nav className="quick-links-section">
        <div className="container">
          <div className="quick-links-grid">
            {modalidades.map((modalidade) => (
              <a
                key={modalidade.id}
                href={`#${modalidade.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="quick-link"
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById(modalidade.name.toLowerCase().replace(/\s+/g, '-'));
                  if (element) {
                    const offset = 150;
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = element.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                  }
                }}
              >
                {modalidade.name}
              </a>
            ))}
          </div>
        </div>
      </nav>

      {/* Modalidades List */}
      <section className="modalidades-list">
        <div className="container">
          {modalidades.map((modalidade, index) => {
            const detalhesInfo = modalidadesDetalhes[modalidade.name] || { detalhes: [] };

            // Escalões dinâmicos vindos da API - mostramos o intervalo (mais novo a mais velho)
            const sportEscalaos = escalaos.filter(e => e.sportIds && e.sportIds.includes(modalidade.id));
            let dynamicEscaloesValue = null;

            if (sportEscalaos.length > 1) {
              const sorted = [...sportEscalaos].sort((a, b) => (a.minAge || 0) - (b.minAge || 0));
              const cleanName = (name) => name.replace(/\s+[A-Z]$/i, '').trim();
              dynamicEscaloesValue = `${cleanName(sorted[0].name)} a ${cleanName(sorted[sorted.length - 1].name)}`;
            } else if (sportEscalaos.length === 1) {
              dynamicEscaloesValue = sportEscalaos[0].name;
            }

            let finalDetalhes = [];
            const staticEscaloes = detalhesInfo.detalhes.find(d => d.label === 'Escalões');

            const escaloesItem = staticEscaloes ? { ...staticEscaloes } : {
              icon: <FaLayerGroup />,
              label: 'Escalões',
              value: 'Formação e Competição'
            };

            if (dynamicEscaloesValue) {
              escaloesItem.value = dynamicEscaloesValue;
            }

            finalDetalhes.push(escaloesItem);

            const sectionId = modalidade.name.toLowerCase().replace(/\s+/g, '-');

            return (
              <article
                key={modalidade.id}
                id={sectionId}
                className={`modalidade-item ${index % 2 === 0 ? '' : 'reverse'}`}
              >
                <div className="modalidade-image">
                  <img src={getImageUrl(modalidade.imageUrl)} alt={modalidade.name} />
                </div>
                <div className="modalidade-content">
                  <span className="section-subtitle">Modalidade</span>
                  <h2>{modalidade.name}</h2>
                  <p className="modalidade-descricao">{modalidade.description}</p>

                  {finalDetalhes && finalDetalhes.length > 0 && (
                    <div className="modalidade-detalhes">
                      {finalDetalhes.map((detalhe, idx) => (
                        <div key={idx} className="detalhe-item">
                          <span className="detalhe-icon">{detalhe.icon}</span>
                          <div className="detalhe-text">
                            <strong>{detalhe.label}</strong>
                            <span>{detalhe.value}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <button
                    className="btn-inscrever"
                    id={`inscrever-btn-${modalidade.id}`}
                    onClick={() => setModalidadeSelecionada(modalidade)}
                  >
                    <MdEmail /> Quero Inscrever-me
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <span className="section-subtitle">Faz Parte da História</span>
          <h2>Pronto para Começar?</h2>
          <p>Junta-te à família CDP e descobre o teu verdadeiro potencial desportivo.</p>
          <div className="cta-buttons">
            <button
              className="btn-primary"
              id="cta-inscrever-btn"
              onClick={() => setModalidadeSelecionada(modalidades[0] || null)}
            >
              Inscrever-me Agora
            </button>
            <Link to="/clube" className="btn-secondary" style={{ textDecoration: 'none' }}>Conhecer o Clube</Link>
          </div>
        </div>
      </section>
      {modalidadeSelecionada && (
        <PreInscricaoModal
          modalidade={modalidadeSelecionada}
          modalidades={modalidades}
          onClose={() => setModalidadeSelecionada(null)}
        />
      )}
    </div>
  );
};

export default Modalidades;